function toggleMenu() {
  if ($('body').hasClass('menu-open')) {
    closeMenu();
  } else {
    openMenu();
  }
}

function openMenu() {
  var menuIsOpen = $('body').hasClass('menu-open');
  if (menuIsOpen) {
    return;
  }
  $('body').addClass('menu-open');
  $('body').addClass('block-scroll');

  $('.nav__overlay').fadeIn({
    duration: 260,
    queue: false
  });
}

function closeMenu() {
  var menuIsOpen = $('body').hasClass('menu-open');
  if (!menuIsOpen) {
    return;
  }
  $('body').removeClass('menu-open');
  $('body').removeClass('block-scroll');

  $('.nav__overlay').fadeOut({
    duration: 260,
    queue: false
  });
}
